module.exports = __webpack_public_path__ + "static/media/slider4.2df82b80.png";